var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDI3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135350",
    "data-name": "Group 135350",
    transform: "translate(-18026.947 -2841.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6008",
    "data-name": "Rectangle 6008",
    d: "M20.221-.75H205.279A21,21,0,0,1,226.25,20.221V205.279a21,21,0,0,1-20.971,20.971H20.221A21,21,0,0,1-.75,205.279V20.221A21,21,0,0,1,20.221-.75ZM205.279,215.38a10.113,10.113,0,0,0,10.1-10.1V20.221a10.113,10.113,0,0,0-10.1-10.1H20.221a10.113,10.113,0,0,0-10.1,10.1V205.279a10.113,10.113,0,0,0,10.1,10.1Z",
    transform: "translate(18027.697 2842.501)",
    fill: "#11162a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1150",
    "data-name": "Ellipse 1150",
    d: "M31.743-.75A32.493,32.493,0,1,1-.75,31.743,32.529,32.529,0,0,1,31.743-.75Zm0,54.116A21.623,21.623,0,1,0,10.12,31.743,21.648,21.648,0,0,0,31.743,53.366Z",
    transform: "translate(18110.875 2923.51)",
    fill: "#11162a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_171",
    "data-name": "Line 171",
    d: "M4.685,50.453A5.435,5.435,0,0,1-.75,45.018V4.685a5.435,5.435,0,1,1,10.87,0V45.018A5.435,5.435,0,0,1,4.685,50.453Z",
    transform: "translate(18137.936 2883.177)",
    fill: "#11162a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_172",
    "data-name": "Line 172",
    d: "M4.685,50.453A5.435,5.435,0,0,1-.75,45.018V4.685a5.435,5.435,0,0,1,10.87,0V45.018A5.435,5.435,0,0,1,4.685,50.453Z",
    transform: "translate(18137.936 2977.5)",
    fill: "#11162a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_173",
    "data-name": "Line 173",
    d: "M45.018,10.12H4.685a5.435,5.435,0,1,1,0-10.87H45.018a5.435,5.435,0,1,1,0,10.87Z",
    transform: "translate(18164.996 2950.569)",
    fill: "#11162a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91136",
    "data-name": "Path 91136",
    d: "M155.12,152.01a72.186,72.186,0,0,1-43.665-14.542,73.427,73.427,0,0,1-25.943-36.862A5.435,5.435,0,1,1,95.9,97.413a61.941,61.941,0,1,0,.019-36.537,5.435,5.435,0,0,1-10.385-3.211A73.461,73.461,0,0,1,111.5,20.877,72.823,72.823,0,1,1,155.12,152.01Z",
    transform: "translate(17987.5 2876.065)",
    fill: "#11162a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1151",
    "data-name": "Ellipse 1151",
    d: "M24.554-.75a25.3,25.3,0,1,1-25.3,25.3A25.333,25.333,0,0,1,24.554-.75Zm0,39.739A14.435,14.435,0,1,0,10.12,24.554,14.451,14.451,0,0,0,24.554,38.989Z",
    transform: "translate(18052.211 2930.652)",
    fill: "#11162a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDI3);
export default __webpack_public_path__ + "static/media/d-i-3.c2d0dbe78e3fce86e21e39ea2fcf5ab4.svg";
export { ForwardRef as ReactComponent };